import { Webcam, Smartphone, Monitor, Video } from "lucide-react";

export const ICONS_BY_TITLE: Record<string, React.ElementType> = {
  Webcam,
  Smartphone,
  Monitor,
  Video,
};

export const getIconByTitle = (title: string): React.ElementType => {
  const map: Record<string, keyof typeof ICONS_BY_TITLE> = {
    "Main Camera": "Webcam",
    "Secondary Camera": "Smartphone",
    "Screen Share": "Monitor",
  };

  return ICONS_BY_TITLE[map[title]] || ICONS_BY_TITLE.Video;
};

const TRACK_TITLE_KEY_BY_SESSION_TYPE: Record<string, string> = {
  "main-camera": "label-proctoring-main-camera",
  "second-camera": "label-proctoring-second-camera",
  screen: "label-proctoring-screen-share",
};

export const getTrackTitleKey = (sessionType: string): string | null =>
  TRACK_TITLE_KEY_BY_SESSION_TYPE[sessionType] ?? null;

export const resolveTrackTitle = (
  sessionType: string,
  fallbackTitle: string,
  tx: (key: string) => string
): string => {
  const key = getTrackTitleKey(sessionType);
  return key ? tx(key) : fallbackTitle;
};
